<template>
  <v-text-field
    v-model="value"
    v-bind="$attrs"
    readonly
    @click="showMenuPicker"
  >
    <template v-slot:append>
      <v-menu
        v-model="showPicker"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
        max-width="400px"
      >
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">{{ value ? value : "mdi-emoticon" }}</v-icon>
        </template>
        <v-card class="ma-0 pa-0">
          <v-toolbar flat dense>
            <v-text-field
              hide-details
              single-line
              :placeholder="$t('Search')"
              v-model="filter"
              prepend-icon="mdi-magnify"
            />
          </v-toolbar>
          <v-card-text class="ma-0 pa-0">
            <v-virtual-scroll
              :bench="bench"
              :items="getIcons"
              height="250"
              item-height="40"
            >
              <template v-slot:default="{ item }">
                <v-btn
                  large
                  icon
                  @click="selectIcon(icon)"
                  v-for="icon in item"
                  :key="icon"
                >
                  <v-icon :title="icon">{{ icon }}</v-icon>
                </v-btn>
              </template>
            </v-virtual-scroll>
          </v-card-text>
        </v-card>
      </v-menu>
    </template>
  </v-text-field>
</template>
<script>
import Icons from "@/ecm/variables/Icons";
export default {
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      showPicker: false,
      filter: "",
      iconList: Icons,
      bench: 0,
    };
  },
  computed: {
    getIcons() {
      var filteredIcons = Icons.filter(
        (i) => i.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1
      );
      var result = [];
      var i,
        j,
        chunk = 5;
      for (i = 0, j = filteredIcons.length; i < j; i += chunk) {
        result.push(filteredIcons.slice(i, i + chunk));
      }

      return result;
    },
  },
  methods: {
    showMenuPicker() {
      this.showPicker = !this.showPicker;
    },
    selectIcon(icon) {
      this.filter = "";
      this.bench = 0;
      this.showPicker = false;
      this.$emit("input", icon);
    },
  },
};
</script>